export const APPLICATION_FILTERS_MODAL_OPENED =
  'jora-employer/filters/APPLICATION_FILTERS_MODAL_OPENED';
export const APPLICATION_FILTERS_CLEARED =
  'jora-employer/filters/APPLICATION_FILTERS_CLEARED';
export const APPLICATION_FILTERS_APPLIED =
  'jora-employer/filters/APPLICATION_FILTERS_APPLIED';
